<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-database-plus
        </v-icon>Create Tax Rate
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="taxName"
                  :rules="[(v) => !!v || 'This field is required']"
                  label="Tax Name*"
                  outlined
                  persistent-hint
                  hint="Name for your reference- 'GST'."
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="state"
                  label="State"
                  outlined
                  disabled
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="taxDescription"
                  label="Tax Description"
                  height="80px"
                  filled
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="6"
                class="pb-0"
              >
                <v-autocomplete
                  v-model="taxType"
                  :items="taxTypes"
                  item-text="name"
                  item-value="value"
                  label="Tax Type"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pb-0"
              >
                <v-text-field
                  v-model="taxPercentage"
                  :rules="[(v) => !!v || 'This field is required']"
                  label="Tax Percentage*"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="pt-0 tax-included-style"
              >
                <v-checkbox
                  v-model="taxIncluded"
                  label="Tax Included*"
                  persistent-hint
                  hint="Default tax included setting is 'exclusive'. For more clarification contact your manager or refer M-002."
                  disabled
                />
              </v-col>
            </v-row>
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="country"
                  :items="countryList"
                  :rules="[(v) => !!v || 'This field is required']"
                  label="Country*"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="country"
                  label="Jurisdiction"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="3"
                class="pt-0"
              >
                <v-switch
                  v-model="status"
                  class="pa-0"
                  label="Status*"
                  color="#FF3700"
                />
              </v-col>
            </v-row>
            <br>
            <p class="text-sm-left">
              *Indicates required field
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createTaxRate()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-dialog>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        taxDescription: null,
        taxPercentage: '',
        taxName: '',
        country: null,
        taxType: null,
        status: false,
        taxIncluded: false,
        loading: false,
        showModal: true,
        state: null,
        taxTypes: [
          { name: 'VAT', value: 'vat' },
          { name: 'Sales Tax', value: 'sales_tax' },
        ],
      };
    },
    computed: {
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
      countryList () {
        return Object.keys(this.CountryCodeList).map((key) => ({ text: this.CountryCodeList[key], value: key }));
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.getCountryCodes();
    },
    methods: {
      async getCountryCodes () {
        await this.$store.dispatch('users/fetchCountryCodes');
      },
      createTaxRate () {
        if (this.$refs.form.validate() === true) {
          this.loading = true;
          this.$store.dispatch('payments/createTaxRate', {
            name: this.taxName,
            description: this.taxDescription,
            tax_type: this.taxType,
            percentage: this.taxPercentage,
            country: this.country,
            jurisdiction: this.country,
            active: this.status,
            inclusive: this.taxIncluded,
            state: this.state,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Tax rate created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.$emit('fetch-tax-rates');
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-input--selection-controls {
  margin-top: 1px;
  padding-top: 0px;
}
.tax-included-style {
  text-align: left;
}
</style>
